/**
 * Detects client browser is FIrefox
 */
export const isFirefox = () => {
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
};
/**
 * Detects client browser is Chrome based
 * Safari, Firefox and legacy Edge are not part of it.
 */
export const isChromeBased = () => {
    const isUserAgentChromeBased = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
    // chromium based Edge has `Edg` in userAgent string while legacy one has `Edge`
    const isUserAgentLegacyEdge = navigator.userAgent.toLowerCase().indexOf('edge') > -1;
    return isUserAgentChromeBased && !isUserAgentLegacyEdge;
};
//# sourceMappingURL=browsers.js.map